interface IColors {
  backgroundPrimary: string,
  white: string,
}

export const Colors: IColors = {
  backgroundPrimary: '#0B1828',
  white: '#FEFEFE',
}